// @flow

export default class SkeletonUtilities {
  static emptyString = (length: number): string =>
    new Array(length + 1).join('_');
}
